export default "__VITE_ASSET__DTCEFLHa__"